export default __webpack_public_path__ + "static/media/img_pst_tier_try.4a38a4ff.svg";